import { pdf } from '@react-pdf/renderer'
import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { IconType } from 'react-icons'
import { FaArrowLeft, FaCoins, FaFileInvoiceDollar } from 'react-icons/fa'
import { HiUsers } from 'react-icons/hi'
import { IoNewspaperOutline } from 'react-icons/io5'
import { RiEditBoxLine } from 'react-icons/ri'
import Button from '../../components/General/Button'
import Datepicker from '../../components/Inputs/Datepicker'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { dateToDB, formatPipe, transformDate } from '../../utils/utils'
import DiaryBook, { IDiaryBooks } from './PdfReports/DiaryBook'
import { saveAs } from 'file-saver'
import { BsFillBookFill } from 'react-icons/bs'
// import writeXlsxFile from 'write-excel-file'
import {
  onCreateAnalysisBookExcel,
  onCreateBalanceSheetExcel,
  onCreateCashFlowExcel,
  onCreateDiaryBookExcel,
  onCreateEstadoResultado,
} from '../../utils/CreateExcel'
import Select from '../../components/Inputs/Select'
import { IoGitMergeSharp } from 'react-icons/io5'
import Analytical from './PdfReports/Analytical'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import { toFixed } from 'accounting'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { getFilesFromBucket, getJsonFromS3 } from '../../utils/UploadFile'
import CashPdf from './PdfReports/CashPdf'
import BalanceSheetPdf from './PdfReports/BalanceSheetPdf'
import InputText from '../../components/Inputs/InputText'
import { userConfigJSON } from '../../userConfig'
import { motion } from 'framer-motion'
import Table from '../../components/Display/Table'
import { ColumnsTable } from 'safe'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import EstadoResultadoPDF from './PdfReports/EstadoResultadoPDF'
import Modal from '../../components/Display/Modal'
import SalesBook from './PdfReports/SalesBook'

const Reports = () => {
  const today = DateTime.local().setLocale('es')

  const server = process.env.REACT_APP_SERVER_URL

  const { addAlert } = useSnackBars()

  const [infoAccount, setInfoAccount] = useState<any | null>(null)

  const [accountPayable, setAccountPayable] = useState<any | null>(null)

  const options = [
    { text: 'Excel', value: 'excel' },
    { text: 'Pdf', value: 'pdf' },
  ]

  const currencyOptions = [
    { text: 'Bolivares', value: 'bsDirectCashFlowStatement' },
    { text: 'USD (Ref)', value: 'usdDirectCashFlowStatement' },
  ]

  const currencyOptionsBalanceSheet = [
    { text: 'Bolivares', value: 'bsMonthlyBalanceSheet' },
    { text: 'USD (Ref)', value: 'usdMonthlyBalanceSheet' },
  ]

  const currencyOptionsIncomeStatement = [
    { text: 'Bolivares', value: 'bsMonthlyIncomeStatement' },
    { text: 'USD (Ref)', value: 'usdMonthlyIncomeStatement' },
  ]

  const [selectedCurrencyOption, setSelectedCurrencyOption] = useState<any[]>(
    []
  )

  const [
    selectedCurrencyIncomeStatement,
    setSelectedCurrencyIncomeStatement,
  ] = useState<null | string>('bsMonthlyIncomeStatement')

  const optionsTypeTime = [
    { text: 'Mensual', value: 'monthly' },
    { text: 'Trimestral', value: 'quarterly' },
    { text: 'Anual', value: 'annual' },
  ]

  const [logOptionsType] = useState([
    { text: 'Todos', value: 'all' },
    { text: 'Crear servicio', value: 'CREATE_SERVICE' },
    { text: 'Editar servicio', value: 'EDIT_SERVICE' },
    { text: 'Eliminar servicio', value: 'DELETE_SERVICE' },
    { text: 'Crear compra', value: 'CREATE_PURCHASE' },
    { text: 'Crear tarifa', value: 'CREATE_RATE' },
    { text: 'Eliminar compra', value: 'DELETE_PURCHASE' },
    { text: 'Crear registro contable', value: 'CREATE_ACCOUNTING_RECORD' },
    { text: 'Eliminar registro contable', value: 'DELETE_ACCOUNTING_RECORD' },
    { text: 'Agregar pago a compra', value: 'ADD_PAYMENT_PURCHASE' },
    { text: 'Crear devolución de compra', value: 'CREATE_RETURN_PURCHASE' },
    { text: 'Agregar reembolso a compra', value: 'ADD_REFUND_PURCHASE' },
    { text: 'Agregar factura a compra', value: 'ADD_BILL_PURCHASE' },
    { text: 'Editar factura de compra', value: 'EDIT_BILL_PURCHASE' },
    { text: 'Crear venta', value: 'CREATE_SALE' },
    { text: 'Eliminar venta', value: 'DELETE_SALE' },
    { text: 'Agregar pago a venta', value: 'ADD_PAYMENT_SALE' },
    { text: 'Crear devolución de venta', value: 'CREATE_RETURN_SALE' },
    { text: 'Agregar reembolso a venta', value: 'ADD_REFUND_SALE' },
    { text: 'Crear artículo', value: 'CREATE_ITEM' },
    { text: 'Editar artículo', value: 'EDIT_ITEM' },
    { text: 'Eliminar artículo', value: 'DELETE_ITEM' },
    { text: 'Cargar artículo', value: 'LOAD_ITEM' },
    { text: 'Descargar artículo', value: 'UNLOAD_ITEM' },
    { text: 'Crear ingreso', value: 'CREATE_INCOME' },
    { text: 'Eliminar ingreso', value: 'DELETE_INCOME' },
    { text: 'Editar ingreso', value: 'EDIT_INCOME' },
    { text: 'Crear pago', value: 'CREATE_PAYMENT' },
    { text: 'Eliminar pago', value: 'DELETE_PAYMENT' },
    { text: 'Editar pago', value: 'EDIT_PAYMENT' },
    { text: 'Recibir artículos de compra', value: 'RECEIVED_ITEMS_PURCHASE' },
    { text: 'Agregar cuenta de dinero', value: 'ADD_MONEY_ACCOUNT' },
    { text: 'Editar cuenta de dinero', value: 'EDIT_MONEY_ACCOUNT' },
    { text: 'Eliminar cuenta de dinero', value: 'DELETE_MONEY_ACCOUNT' },
    { text: 'Agregar categoría de artículo', value: 'ADD_ITEM_CATEGORY' },
    { text: 'Editar categoría de artículo', value: 'EDIT_ITEM_CATEGORY' },
    { text: 'Eliminar categoría de artículo', value: 'DELETE_ITEM_CATEGORY' },
    { text: 'Agregar almacén', value: 'ADD_WAREHOUSE' },
    { text: 'Editar almacén', value: 'EDIT_WAREHOUSE' },
    { text: 'Eliminar almacén', value: 'DELETE_WAREHOUSE' },
    { text: 'Crear usuario', value: 'CREATE_USER' },
    { text: 'Eliminar usuario', value: 'DELETE_USER' },
    { text: 'Editar usuario', value: 'EDIT_USER' },
    { text: 'Personalizado', value: 'CUSTOM' },
    { text: 'Ajustar precio', value: 'ADJUST_PRICE' },
    { text: 'Crear suscripción', value: 'CREATE_SUBSCRIPTION' },
    { text: 'Eliminar suscripción', value: 'DELETE_SUBSCRIPTION' },
    { text: 'Editar suscripción', value: 'EDIT_SUBSCRIPTION' },
  ])

  const [optionsValues, setOptionsValues] = useState<any[]>([])

  const [
    optionsValuesIncomeStatement,
    setOptionsValuesIncomeStatement,
  ] = useState<any[]>([])

  const [selectedOptionValue, setSelectedOptionValue] = useState<any | null>(
    null
  )

  const [
    selectedOptionValueIncomeStatement,
    setSelectedOptionValueIncomeStatement,
  ] = useState<any | null>(null)

  const [salesBook, setSalesBook] = useState<any | null>(null)

  const monthTransform = {
    '1': 'Enero',
    '2': 'Febrero',
    '3': 'Marzo',
    '4': 'Abril',
    '5': 'Mayo',
    '6': 'Junio',
    '7': 'Julio',
    '8': 'Agosto',
    '9': 'Septiembre',
    '10': 'Octubre',
    '11': 'Noviembre',
    '12': 'Diciembre',
  }

  const [selectedType, setSelectedType] = useState<any | null>(null)

  const [beforeBalance, setBeforeBalance] = useState(0)

  const [logsState, setLogsState] = useState<any>({
    logs: [],
    numberOfPages: '0',
    currentPage: 0,
    loading: false,
    filterValues: [],
  })

  const [openModal, setOpenModal] = useState<boolean>(false)

  const user = useSelector((state: RootState) => state?.auth?.user)

  let PRUEBA_RESPONSE = {
    bsMonthlyIncomeStatement: [
      {
        code: '0',
        name: 'ROOT',
        parentid: 0,
        id: '1',
        period: '2023-6',
        bsNetIncome: 124385.88,
        children: [
          {
            code: '4',
            bsBalance: '124639.08',
            name: 'INGRESOS',
            parentid: '1',
            id: '5',
            children: [
              {
                code: '4.1',
                bsBalance: '124586.59',
                name: 'OPERACIONES CONTINUAS ORDINARIAS',
                parentid: '5',
                id: '227',
                children: [
                  {
                    code: '4.1.1',
                    bsBalance: '124586.59',
                    name: 'VENTAS NETAS DE MERCANIA GRAVABLES',
                    parentid: '227',
                    id: '228',
                    children: [
                      {
                        code: '4.1.1.1',
                        bsBalance: '124586.59',
                        name: 'VENTAS BRUTAS DE MERCANCIA',
                        parentid: '228',
                        id: '229',
                        children: [
                          {
                            code: '4.1.1.1.01',
                            bsBalance: '124586.59',
                            name: 'VENTAS BRUTAS DE MERCANCIA NACIONALES',
                            parentid: '229',
                            id: '230',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                code: '4.2',
                bsBalance: '52.49',
                name: 'OPERACIONES CONTINUAS NO ORDINARIAS',
                parentid: '5',
                id: '234',
                children: [
                  {
                    code: '4.2.1',
                    bsBalance: '52.49',
                    name: 'INGRESOS NO ORDINARIOS',
                    parentid: '234',
                    id: '235',
                    children: [
                      {
                        code: '4.2.1.2',
                        bsBalance: '52.49',
                        name: 'OTROS INGRESOS NO ORDINARIOS',
                        parentid: '235',
                        id: '248',
                        children: [
                          {
                            code: '4.2.1.2.05',
                            bsBalance: '52.49',
                            name: 'OTRO TIPO DE INGRESOS NO ORDINARIOS',
                            parentid: '248',
                            id: '400',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            code: '6',
            bsBalance: '253.20',
            name: 'GASTOS',
            parentid: '1',
            id: '7',
            children: [
              {
                code: '6.2',
                bsBalance: '253.20',
                name: 'OPERACIONES CONTÍNUAS NO ORDINARIAS',
                parentid: '7',
                id: '372',
                children: [
                  {
                    code: '6.2.1',
                    bsBalance: '253.20',
                    name: 'GASTOS NO ORDINARIOS',
                    parentid: '372',
                    id: '373',
                    children: [
                      {
                        code: '6.2.1.1',
                        bsBalance: '253.20',
                        name: 'GASTOS FINANCIEROS',
                        parentid: '373',
                        id: '374',
                        children: [
                          {
                            code: '6.2.1.1.03',
                            bsBalance: '253.20',
                            name: 'EGRESOS FINANCIEROS COMERCIALES',
                            parentid: '374',
                            id: '378',
                            children: [
                              {
                                code: '6.2.1.1.03-002',
                                bsBalance: '253.20',
                                name:
                                  'Descuentos otorgados P/Pronto pago en Ventas',
                                parentid: '378',
                                id: '380',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    usdMonthlyIncomeStatement: [
      {
        code: '0',
        name: 'ROOT',
        parentid: 0,
        id: '1',
        period: '2023-6',
        usdNetIncome: 4607.33,
        children: [
          {
            code: '4',
            usdBalance: '4616.65',
            name: 'INGRESOS',
            parentid: '1',
            id: '5',
            children: [
              {
                code: '4.1',
                usdBalance: '4614.68',
                name: 'OPERACIONES CONTINUAS ORDINARIAS',
                parentid: '5',
                id: '227',
                children: [
                  {
                    code: '4.1.1',
                    usdBalance: '4614.68',
                    name: 'VENTAS NETAS DE MERCANIA GRAVABLES',
                    parentid: '227',
                    id: '228',
                    children: [
                      {
                        code: '4.1.1.1',
                        usdBalance: '4614.68',
                        name: 'VENTAS BRUTAS DE MERCANCIA',
                        parentid: '228',
                        id: '229',
                        children: [
                          {
                            code: '4.1.1.1.01',
                            usdBalance: '4614.68',
                            name: 'VENTAS BRUTAS DE MERCANCIA NACIONALES',
                            parentid: '229',
                            id: '230',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                code: '4.2',
                usdBalance: '1.97',
                name: 'OPERACIONES CONTINUAS NO ORDINARIAS',
                parentid: '5',
                id: '234',
                children: [
                  {
                    code: '4.2.1',
                    usdBalance: '1.97',
                    name: 'INGRESOS NO ORDINARIOS',
                    parentid: '234',
                    id: '235',
                    children: [
                      {
                        code: '4.2.1.2',
                        usdBalance: '1.97',
                        name: 'OTROS INGRESOS NO ORDINARIOS',
                        parentid: '235',
                        id: '248',
                        children: [
                          {
                            code: '4.2.1.2.05',
                            usdBalance: '1.97',
                            name: 'OTRO TIPO DE INGRESOS NO ORDINARIOS',
                            parentid: '248',
                            id: '400',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            code: '6',
            usdBalance: '9.32',
            name: 'GASTOS',
            parentid: '1',
            id: '7',
            children: [
              {
                code: '6.2',
                usdBalance: '9.32',
                name: 'OPERACIONES CONTÍNUAS NO ORDINARIAS',
                parentid: '7',
                id: '372',
                children: [
                  {
                    code: '6.2.1',
                    usdBalance: '9.32',
                    name: 'GASTOS NO ORDINARIOS',
                    parentid: '372',
                    id: '373',
                    children: [
                      {
                        code: '6.2.1.1',
                        usdBalance: '9.32',
                        name: 'GASTOS FINANCIEROS',
                        parentid: '373',
                        id: '374',
                        children: [
                          {
                            code: '6.2.1.1.03',
                            usdBalance: '9.32',
                            name: 'EGRESOS FINANCIEROS COMERCIALES',
                            parentid: '374',
                            id: '378',
                            children: [
                              {
                                code: '6.2.1.1.03-002',
                                usdBalance: '9.32',
                                name:
                                  'Descuentos otorgados P/Pronto pago en Ventas',
                                parentid: '378',
                                id: '380',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  }

  const [cardOptions] = useState<
    { icon: IconType; title: string; subTitle: string }[]
  >([
    {
      icon: IoNewspaperOutline,
      title: 'Estado de Situación Financiera',
      subTitle: 'Solo boton de descargar',
    },
    {
      icon: FaCoins,
      title: 'Estado de Flujo de Efectivo',
      subTitle: '',
    },
    {
      icon: RiEditBoxLine,
      title: 'Estado de Resultados',
      subTitle: '',
    },
    {
      icon: BsFillBookFill,
      title: 'Libro diario',
      subTitle: '',
    },
    {
      icon: IoGitMergeSharp,
      title: 'Mayor analítico',
      subTitle: '',
    },
    {
      icon: HiUsers,
      title: 'Eventos de usuarios',
      subTitle: '',
    },
    {
      icon: FaFileInvoiceDollar,
      title: 'Libro de venta',
      subTitle: '',
    },
  ])

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => {
        
        return (
          <ColumnItemWrapper subElement="paragraph">
            {transformDate(new Date(record?.date).toISOString())}
          </ColumnItemWrapper>
        )
      }
    },
    {
      title: 'Hora',
      dataIndex: 'hour',
      key: 'hour',
      render: (id: number, record: any) => {
        let value = record?.date
        let hour = ''
        if (value) {
          try {
            hour = value.split('T')[1]?.slice(0,5) || ''
          } catch {
            hour = ''
          }
        }
        return (
          <ColumnItemWrapper subElement="paragraph">
            {hour}
          </ColumnItemWrapper>
        )
      },
    },

    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => {
        let value =
          logOptionsType.find((log) => log?.value === record?.type)?.text || ''

        return (
          <ColumnItemWrapper
          // subElement="paragraph"
          // subElementStyle="dark:text-white text-black"
          >
            {value}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
    },
  ]

  const [cardValues, setCardValues] = useState<any[]>(
    [...new Array(cardOptions.length)].map((v, idx) => {
      if (idx === 0) {
        return {
          currencyValue: 'bsMonthlyBalanceSheet'
        }
      }
      if (idx === 1) {
        return {
          currencyValue: 'bsDirectCashFlowStatement'
        }
      }
      if (idx === 2) {
        return {
          currencyValue: 'bsMonthlyIncomeStatement'
        }
      }
      return {}
    })
  )

  function addLevelToTree(tree: any[]): any[] {
    function flattenTree(tree: any[], level: number = 0): any[] {
      return tree.reduce((acc: any[], node: any) => {
        const newNode: any = { ...node, level }
        acc.push(newNode)

        if (node.children) {
          acc.push(...flattenTree(node.children, level + 1))
        }

        return acc
      }, [])
    }

    return flattenTree(tree)
  }

  const [thermalPrinter, setThermalPrinter] = useState<null | any>(null)

  const onGetThermalPrinterInfo = async () => {
    let response = await axios.get(`${server}/thermal-printer`)
    if (response.data.printers.length > 0) {
      setThermalPrinter(  response.data.printers[0])
    }
  }

  useEffect(() => {
    onGetThermalPrinterInfo()
  }, [])

  useEffect(() => {
    let value = [...cardValues]
    value[1] = {
      bucketValue: "MonthlyDirectCashStatement"
    }
    value[3] = {
      startedDate: `${today.day}/${today.month}/${today.year}`,
      endDate: `${today.day}/${today.month}/${today.year}`,
    }
    value[4] = {
      startedDate: `${today.day}/${today.month}/${today.year}`,
      endDate: `${today.day}/${today.month}/${today.year}`,
    }
    value[5] = {
      startedDate: `${today.day}/${today.month}/${today.year}`,
      endDate: `${today.day}/${today.month}/${today.year}`,
      username: '',
    }
    setCardValues(value)
  }, [])

  /** Recibe una fecha tipo: 12-2022 */
  const parseDate = (date: string): string => {
    const [month, year] = date.split('-')
    return `${monthTransform[month]} - ${year}`
  }

  const getFilesBucket = async (v = 'MonthlyDirectCashStatement') => {
    const respArray = await getFilesFromBucket(user['custom:tenant_id'], v)
    let newArray = respArray?.map((v) => ({
      value: v,
      text: v === 'MonthlyDirectCashStatement' ? parseDate(v as string) : v,
    })) as any[]


    console.log("newArray", newArray)
    setOptionsValues(newArray)
    setSelectedOptionValue(newArray[0])
  }

  const getFilesBucketIncomeStatement = async (
    v = 'MonthlyIncomeStatement'
  ) => {
    const respArray = await getFilesFromBucket(user['custom:tenant_id'], v)
    console.log("respArray 02", respArray)
    let newArray = respArray?.map((v) => ({
      value: v,
      text: v === 'MonthlyIncomeStatement' ? parseDate(v as string) : v,
    })) as any[]
    console.log("newArray 02", newArray)
    setOptionsValuesIncomeStatement(newArray)
    setSelectedOptionValueIncomeStatement(newArray[0])
  }

  useEffect(() => {
    // getFilesBucket()
  }, [])

  const onGetReport = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    setInfoAccount(response?.data?.tenant)
  }

  useEffect(() => {
    onGetReport()
  }, [])

  const onGetLogs = async (currentPage: number = 0, filterValues) => {
    setLogsState((prevState) => ({
      ...prevState,
      currentPage,
      loading: true,
      filterValues,
    }))
    if (filterValues.username === '') {
      delete filterValues.username
    }

    if (filterValues.type === 'all') {
      delete filterValues.type
    }

    const values = Object.keys(filterValues).map(
      (v) => `${v}=${filterValues[v]}`
    )

    console.log("values", values)
    let resp = await axios.get(
      `${server}/log?pageNumber=${currentPage + 1}&pageSize=${
        userConfigJSON.rowsPerPage
      }&${values.join('&')}`
    )
    if (resp?.data?.logs?.length === 0) {
      addAlert({ message: 'No hay eventos para mostrar', status: 'error' })
    }
    setLogsState((prevState) => ({
      ...prevState,
      ...resp.data,
      loading: false,
    }))
  }

  const onClickCard = (index: number) => {}

  // return <div style={{height: '100vh'}}>
  //   <DiaryBook />
  // </div>

  const [showPDF, setShowPDF] = useState(false)

  const [data, setdata] = useState([])

  const generatePdf = async (
    index: number,
    data: any,
    { beforeBalance, finalBalance }: any
  ): Promise<void> => {
    if (index === 3) {
      // let response = await axios.get(`${server}/user/tenant`)
      // let infoAccount = response?.data?.tenant

      // setdata(data.map((v) => ({
      //         date: v?.date,
      //         amount: v?.amount,
      //         description: v?.description,
      //         name: v?.name,
      //         type: v?.type === 'DEBIT' ? 'DEBE' : 'HABER',
      //         code: v?.code
      //       })).slice(0, 5))
      // setShowPDF(true)
      const blob = await pdf(
        <DiaryBook
          businessSocial={infoAccount?.businessSocial}
          businessDocument={`${infoAccount?.document?.documentType}-${infoAccount?.document?.document}`}
          dateFrom={cardValues[index]?.startedDate}
          dateTo={cardValues[index]?.endDate}
          data={data.map((v) => ({
            date: v?.date,
            amount: v?.amount,
            description: v?.description,
            name: v?.name,
            type: v?.type === 'DEBIT' ? 'DEBE' : 'HABER',
            code: v?.code,
          }))}
        />
      ).toBlob()
      saveAs(blob, 'Libro_diario')

      return
    }
    if (index === 4) {
      const blob = await pdf(
        <Analytical
          accountName={accountPayable?.name}
          accountCode={accountPayable?.code}
          parentCode={accountPayable.parentCode}
          parentName={accountPayable.parentName}
          parentBalance={formatPipe(
            toFixed(finalBalance, 2),
            false,
            2,
            -9999999999999999999
          )}
          parentBeforeBalance={formatPipe(
            toFixed(beforeBalance, 2),
            false,
            2,
            -9999999999999999999
          )}
          businessSocial={infoAccount?.businessSocial}
          businessDocument={`${infoAccount?.document?.documentType}-${infoAccount?.document?.document}`}
          dateFrom={cardValues[index]?.startedDate}
          dateTo={cardValues[index]?.endDate}
          data={data.map((v) => ({
            date: v?.date,
            amount: v?.amount,
            description: v?.description,
            name: v?.name,
            type: v?.type === 'DEBIT' ? 'DEBE' : 'HABER',
            code: v?.code,
          }))}
        />
      ).toBlob()
      saveAs(blob, 'Mayor_Analítico')

      return
    }

   
  }

  const renderContent = (index: number) => {
    if (index === 0) {
      return (
        <>
          <div style={{ width: '100%' }}>
            <div className="flex flex-row justify-between">
              {/* <div style={{ width: '45%' }}>
                <Select
                  options={currencyOptionsBalanceSheet}
                  label="Moneda"
                  defaultValue={currencyOptionsBalanceSheet[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      let values = [...cardValues]
                      values[index] = {
                        ...values[index],
                        currencyValue: v?.value,
                      }
                      setCardValues(values)
                    }
                  }}
                />
              </div> */}

              <div style={{ width: '45%' }}>
                <Select
                  options={options}
                  label="Tipo de archivo"
                  defaultValue={options[0]}
                  // value={selectedOptionValue}
                  onChange={(v) => {
                    if (v?.value) {
                      setSelectedType((prevState) => ({
                        ...prevState,
                        [index]: v?.value,
                      }))
                    }
                  }}
                />
              </div>
            </div>

            <div style={{ width: '100%', marginTop: 70 }}>
              <div className="flex flex-row justify-center">
                <label
                  className="text-primary text-base font-medium cursor-pointer"
                  onClick={async () => {

                    console.log("SELECTED TYPE", cardValues[index]?.currencyValue)
                    try {
                      const response = await getJsonFromS3(
                        user['custom:tenant_id'],
                        `BalanceSheet.json`
                      )

                      // let response = {"tenant":{"business_name":"Waku Software LLC","document":"123","document_type":"V"},"bsMonthlyBalanceSheet":[{"code":"0","name":"ROOT","parentid":0,"id":"1","period":"2025-3","children":[{"code":"1","balance":"26898.91","name":"ACTIVOS","parentid":"1","id":"2","children":[{"code":"1.1","balance":"26898.91","name":"ACTIVO CORRIENTE","parentid":"2","id":"8","children":[{"code":"1.1.1","balance":"-2192932.08","name":"EFECTIVO","parentid":"8","id":"9","children":[{"code":"1.1.1.1","balance":"0.00","name":"CAJA","parentid":"9","id":"10","children":[{"code":"1.1.1.1.01","balance":"0.00","name":"EFECTIVO DISPONIBLE EN CAJA","parentid":"10","id":"11"}]},{"code":"1.1.1.2","balance":"-2192932.08","name":"BANCOS","parentid":"9","id":"13","children":[{"code":"1.1.1.2.01","balance":"-2192932.08","name":"BANCOS NACIONALES","parentid":"13","id":"14","children":[{"code":"1.1.1.2.01-001","balance":"-2192932.08","name":"Cuenta Ventas","parentid":"14","id":"777"}]}]}]},{"code":"1.1.2","balance":"2182483.55","name":"CUENTAS POR COBRAR CORRIENTES","parentid":"8","id":"16","children":[{"code":"1.1.2.1","balance":"2182483.55","name":"CUENTAS POR COBRAR COMERCIALES","parentid":"16","id":"17","children":[{"code":"1.1.2.1.01","balance":"2182483.55","name":"CUENTAS P/COBRAR COMERCIALES NACIONALES","parentid":"17","id":"18"}]}]},{"code":"1.1.3","balance":"35481.84","name":"INVENTARIOS","parentid":"8","id":"23","children":[{"code":"1.1.3.1","balance":"35481.84","name":"MERCANCIAS","parentid":"23","id":"24","children":[{"code":"1.1.3.1.01","balance":"35374.14","name":"MERCANCIAS DISPONIBLE P/LA VENTA","parentid":"24","id":"25","children":[{"code":"1.1.3.1.01-001","balance":"35374.14","name":"Harinas","parentid":"25","id":"776"}]},{"code":"1.1.3.1.04","balance":"107.70","name":"MERCANCIA EN TRANSITO","parentid":"24","id":"29"}]}]},{"code":"1.1.4","balance":"1865.60","name":"DERECHOS TRIBUTARIOS CORRIENTES","parentid":"8","id":"42","children":[{"code":"1.1.4.1","balance":"1865.60","name":"IMPUESTOS CORRIENTES ACREDITABLES","parentid":"42","id":"43","children":[{"code":"1.1.4.1.01","balance":"0.00","name":"IMPUESTO S/LA RENTA ACREDITABLE","parentid":"43","id":"44","children":[{"code":"1.1.4.1.01-002","balance":"0.00","name":"ISLR retenido por clientes","parentid":"44","id":"46"}]},{"code":"1.1.4.1.02","balance":"1865.60","name":"IMPUESTO AL VALOR AGREGADO ACREDITABLE","parentid":"43","id":"48","children":[{"code":"1.1.4.1.02-001","balance":"1865.60","name":"Creditos Fiscales IVA-Compras nacionales","parentid":"48","id":"49"},{"code":"1.1.4.1.02-003","balance":"0.00","name":"IVA retenido por Clientes","parentid":"48","id":"51"}]},{"code":"1.1.4.1.03","balance":"0.00","name":"IMPUESTOS MUNICIPALES ACREDITABLES","parentid":"43","id":"52","children":[{"code":"1.1.4.1.03-002","balance":"0.00","name":"Impuestos Municipales retenidos por Clientes","parentid":"52","id":"54"}]}]}]}]},{"code":"2","balance":"371.68","name":"PASIVOS","parentid":"1","id":"3","children":[{"code":"2.1","balance":"371.68","name":"PASIVO CORRIENTE","parentid":"3","id":"119","children":[{"code":"2.1.1","balance":"0.00","name":"CUENTAS POR PAGAR CORRIENTES","parentid":"119","id":"120","children":[{"code":"2.1.1.1","balance":"0.00","name":"CUENTAS POR PAGAR COMERCIALES CORRIENTES","parentid":"120","id":"121","children":[{"code":"2.1.1.1.01","balance":"0.00","name":"CTAS P/PAGAR COMER. CORRIENTES NACIONALES","parentid":"121","id":"122"}]},{"code":"2.1.1.2","balance":"0.00","name":"OTRAS CUENTAS P/PAGAR CORRIENTES","parentid":"120","id":"124","children":[{"code":"2.1.1.2.02","balance":"0.00","name":"CTAS P/PAGAR A SOCIOS O DIRECTORES","parentid":"124","id":"126"}]}]},{"code":"2.1.3","balance":"371.68","name":"OBLIGACIONES TRIBUTARIAS CORRIENTES","parentid":"119","id":"156","children":[{"code":"2.1.3.1","balance":"371.68","name":"IMPUESTOS CORRIENTES","parentid":"156","id":"157","children":[{"code":"2.1.3.1.02","balance":"371.68","name":"IVA P/PAGAR","parentid":"157","id":"162","children":[{"code":"2.1.3.1.02-001","balance":"371.68","name":"Debitos Fiscales IVA - Ventas Nacionales","parentid":"162","id":"163"}]},{"code":"2.1.3.1.04","balance":"0.00","name":"IGTF P/PAGAR","parentid":"157","id":"398","children":[{"code":"2.1.3.1.04-001","balance":"0.00","name":"Debitos Fiscales IGTF - Ventas Nacionales","parentid":"398","id":"399"}]}]}]}]},{"code":"3","balance":"37940.00","name":"PATRIMONIO","parentid":"1","id":"4","children":[{"code":"3.1","balance":"37940.00","name":"CAPITAL SOCIAL APORTADO","parentid":"4","id":"193","children":[{"code":"3.1.2","balance":"37940.00","name":"APORTES DE ACCIONISTAS P/CAPITALIZAR","parentid":"193","id":"197","children":[{"code":"3.1.2.1","balance":"37940.00","name":"APORTES P/CAPITALIZAR DE ACCIONISTAS COMUNES","parentid":"197","id":"198"}]}]},{"code":"3.4","balance":"0.00","name":"RESULTADOS ACUMULADOS","parentid":"4","id":"210","children":[{"code":"3.4.1","balance":"0.00","name":"RESULTADOS DE LA ACTIVIDAD","parentid":"210","id":"211","children":[{"code":"3.4.1.2","balance":"0.00","name":"RESULTADO DEL EJERCICIO","parentid":"211","id":"215","children":[{"code":"3.4.1.2.01","balance":"104.28","name":"Ganancia (Pérdida) del ejercicio","parentid":"215","id":"216"}]}]}]}]},{"code":"4","balance":"2705.39","name":"INGRESOS","parentid":"1","id":"5","children":[{"code":"4.1","balance":"2705.07","name":"OPERACIONES CONTINUAS ORDINARIAS","parentid":"5","id":"227","children":[{"code":"4.1.1","balance":"2705.07","name":"VENTAS NETAS DE MERCANIA GRAVABLES","parentid":"227","id":"228","children":[{"code":"4.1.1.1","balance":"2705.07","name":"VENTAS BRUTAS DE MERCANCIA","parentid":"228","id":"229","children":[{"code":"4.1.1.1.01","balance":"2705.07","name":"VENTAS BRUTAS DE MERCANCIA NACIONALES","parentid":"229","id":"230"}]}]}]},{"code":"4.2","balance":"0.32","name":"OPERACIONES CONTINUAS NO ORDINARIAS","parentid":"5","id":"234","children":[{"code":"4.2.1","balance":"0.32","name":"INGRESOS NO ORDINARIOS","parentid":"234","id":"235","children":[{"code":"4.2.1.1","balance":"0.00","name":"INGRESOS FINANCIEROS","parentid":"235","id":"236","children":[{"code":"4.2.1.1.04","balance":"0.00","name":"GANANCIA EN CAMBIO DE MONEDA EXTRANJERA","parentid":"236","id":"245"}]},{"code":"4.2.1.2","balance":"0.32","name":"OTROS INGRESOS NO ORDINARIOS","parentid":"235","id":"248","children":[{"code":"4.2.1.2.05","balance":"0.32","name":"OTRO TIPO DE INGRESOS NO ORDINARIOS","parentid":"248","id":"400"}]}]}]}]},{"code":"5","balance":"2637.66","name":"COSTOS","parentid":"1","id":"6","children":[{"code":"5.2","balance":"2637.66","name":"COSTO DE VENTA","parentid":"6","id":"292","children":[{"code":"5.2.1","balance":"2637.66","name":"COSTO DE VENTA DE LA MERCANCÍA COMPRADA","parentid":"292","id":"293","children":[{"code":"5.2.1.1","balance":"2637.66","name":"COMPRAS NETAS DE MERCANCÍA","parentid":"293","id":"294","children":[{"code":"5.2.1.1.01","balance":"2637.66","name":"COMPRAS BRUTAS DE MERCANCÍA NACIONALES","parentid":"294","id":"295"}]}]}]}]},{"code":"6","balance":"0.00","name":"GASTOS","parentid":"1","id":"7","children":[{"code":"6.1","balance":"0.00","name":"OPERACIONES CONTÍNUAS ORDINARIAS","parentid":"7","id":"303","children":[{"code":"6.1.2","balance":"0.00","name":"GASTOS DE GESTIÓN ADMINISTRATIVA","parentid":"303","id":"331","children":[{"code":"6.1.2.1","balance":"0.00","name":"GASTOS DEL PERSONAL DE ADMINISTRACIÓN","parentid":"331","id":"332","children":[{"code":"6.1.2.1.01","balance":"0.00","name":"BENEFICIOS LABORALES REMUNERATIVOS DE ADMINISTRACIÓN","parentid":"332","id":"333","children":[{"code":"6.1.2.1.01-002","balance":"0.00","name":"Sueldos a Empleados","parentid":"333","id":"335"}]}]},{"code":"6.1.2.2","balance":"0.00","name":"GASTOS GENERALES DE ADMON.","parentid":"331","id":"353","children":[{"code":"6.1.2.2.02","balance":"0.00","name":"IMPUESTOS Y TASAS","parentid":"353","id":"357","children":[{"code":"6.1.2.2.02-001","balance":"0.00","name":"Pago ISLR","parentid":"357","id":"470"},{"code":"6.1.2.2.02-003","balance":"0.00","name":"Pago Otros Impuestos y Tasas","parentid":"357","id":"472"}]},{"code":"6.1.2.2.05","balance":"0.00","name":"GASTOS DE SERVICIOS PÚBLICOS DE ADMON.","parentid":"353","id":"360"},{"code":"6.1.2.2.06","balance":"0.00","name":"MATERIALES Y SUMINISTROS DE OFICINA DE ADMON.","parentid":"353","id":"361"}]}]},{"code":"6.1.3","balance":"0.00","name":"OTROS GASTOS ORDINARIOS","parentid":"303","id":"401","children":[{"code":"6.2.1.1","balance":"0.00","name":"OTROS GASTOS OPERATIVOS ORDINARIOS","parentid":"401","id":"402"}]}]},{"code":"6.2","balance":"0.00","name":"OPERACIONES CONTÍNUAS NO ORDINARIAS","parentid":"7","id":"372","children":[{"code":"6.2.1","balance":"0.00","name":"GASTOS NO ORDINARIOS","parentid":"372","id":"373","children":[{"code":"6.2.1.1","balance":"0.00","name":"GASTOS FINANCIEROS","parentid":"373","id":"374","children":[{"code":"6.2.1.1.06","balance":"0.00","name":"COMISIONES PAGADAS A INSTITUC. FINANCIERAS","parentid":"374","id":"403"}]}]}]}],"usdMonthlyBalanceSheet":[{"code":"0","name":"ROOT","parentid":0,"id":"1","period":"2025-3","children":[{"code":"1","balance":"588.55","name":"ACTIVOS","parentid":"1","id":"2","children":[{"code":"1.1","balance":"588.55","name":"ACTIVO CORRIENTE","parentid":"2","id":"8","children":[{"code":"1.1.1","balance":"-33595.71","name":"EFECTIVO","parentid":"8","id":"9","children":[{"code":"1.1.1.1","balance":"0.00","name":"CAJA","parentid":"9","id":"10","children":[{"code":"1.1.1.1.01","balance":"0.00","name":"EFECTIVO DISPONIBLE EN CAJA","parentid":"10","id":"11"}]},{"code":"1.1.1.2","balance":"-33595.71","name":"BANCOS","parentid":"9","id":"13","children":[{"code":"1.1.1.2.01","balance":"-33595.71","name":"BANCOS NACIONALES","parentid":"13","id":"14","children":[{"code":"1.1.1.2.01-001","balance":"-33595.71","name":"Cuenta Ventas","parentid":"14","id":"777"}]}]}]},{"code":"1.1.2","balance":"33437.77","name":"CUENTAS POR COBRAR CORRIENTES","parentid":"8","id":"16","children":[{"code":"1.1.2.1","balance":"33437.77","name":"CUENTAS POR COBRAR COMERCIALES","parentid":"16","id":"17","children":[{"code":"1.1.2.1.01","balance":"33437.77","name":"CUENTAS P/COBRAR COMERCIALES NACIONALES","parentid":"17","id":"18"}]}]},{"code":"1.1.3","balance":"717.91","name":"INVENTARIOS","parentid":"8","id":"23","children":[{"code":"1.1.3.1","balance":"717.91","name":"MERCANCIAS","parentid":"23","id":"24","children":[{"code":"1.1.3.1.01","balance":"716.26","name":"MERCANCIAS DISPONIBLE P/LA VENTA","parentid":"24","id":"25","children":[{"code":"1.1.3.1.01-001","balance":"716.26","name":"Harinas","parentid":"25","id":"776"}]},{"code":"1.1.3.1.04","balance":"1.65","name":"MERCANCIA EN TRANSITO","parentid":"24","id":"29"}]}]},{"code":"1.1.4","balance":"28.58","name":"DERECHOS TRIBUTARIOS CORRIENTES","parentid":"8","id":"42","children":[{"code":"1.1.4.1","balance":"28.58","name":"IMPUESTOS CORRIENTES ACREDITABLES","parentid":"42","id":"43","children":[{"code":"1.1.4.1.01","balance":"0.00","name":"IMPUESTO S/LA RENTA ACREDITABLE","parentid":"43","id":"44","children":[{"code":"1.1.4.1.01-002","balance":"0.00","name":"ISLR retenido por clientes","parentid":"44","id":"46"}]},{"code":"1.1.4.1.02","balance":"28.58","name":"IMPUESTO AL VALOR AGREGADO ACREDITABLE","parentid":"43","id":"48","children":[{"code":"1.1.4.1.02-001","balance":"28.58","name":"Creditos Fiscales IVA-Compras nacionales","parentid":"48","id":"49"},{"code":"1.1.4.1.02-003","balance":"0.00","name":"IVA retenido por Clientes","parentid":"48","id":"51"}]},{"code":"1.1.4.1.03","balance":"0.00","name":"IMPUESTOS MUNICIPALES ACREDITABLES","parentid":"43","id":"52","children":[{"code":"1.1.4.1.03-002","balance":"0.00","name":"Impuestos Municipales retenidos por Clientes","parentid":"52","id":"54"}]}]}]}]},{"code":"2","balance":"5.69","name":"PASIVOS","parentid":"1","id":"3","children":[{"code":"2.1","balance":"5.69","name":"PASIVO CORRIENTE","parentid":"3","id":"119","children":[{"code":"2.1.1","balance":"0.00","name":"CUENTAS POR PAGAR CORRIENTES","parentid":"119","id":"120","children":[{"code":"2.1.1.1","balance":"0.00","name":"CUENTAS POR PAGAR COMERCIALES CORRIENTES","parentid":"120","id":"121","children":[{"code":"2.1.1.1.01","balance":"0.00","name":"CTAS P/PAGAR COMER. CORRIENTES NACIONALES","parentid":"121","id":"122"}]},{"code":"2.1.1.2","balance":"0.00","name":"OTRAS CUENTAS P/PAGAR CORRIENTES","parentid":"120","id":"124","children":[{"code":"2.1.1.2.02","balance":"0.00","name":"CTAS P/PAGAR A SOCIOS O DIRECTORES","parentid":"124","id":"126"}]}]},{"code":"2.1.3","balance":"5.69","name":"OBLIGACIONES TRIBUTARIAS CORRIENTES","parentid":"119","id":"156","children":[{"code":"2.1.3.1","balance":"5.69","name":"IMPUESTOS CORRIENTES","parentid":"156","id":"157","children":[{"code":"2.1.3.1.02","balance":"5.69","name":"IVA P/PAGAR","parentid":"157","id":"162","children":[{"code":"2.1.3.1.02-001","balance":"5.69","name":"Debitos Fiscales IVA - Ventas Nacionales","parentid":"162","id":"163"}]},{"code":"2.1.3.1.04","balance":"0.00","name":"IGTF P/PAGAR","parentid":"157","id":"398","children":[{"code":"2.1.3.1.04-001","balance":"0.00","name":"Debitos Fiscales IGTF - Ventas Nacionales","parentid":"398","id":"399"}]}]}]}]}]},{"code":"3","balance":"757.29","name":"PATRIMONIO","parentid":"1","id":"4","children":[{"code":"3.1","balance":"757.29","name":"CAPITAL SOCIAL APORTADO","parentid":"4","id":"193","children":[{"code":"3.1.2","balance":"757.29","name":"APORTES DE ACCIONISTAS P/CAPITALIZAR","parentid":"193","id":"197","children":[{"code":"3.1.2.1","balance":"757.29","name":"APORTES P/CAPITALIZAR DE ACCIONISTAS COMUNES","parentid":"197","id":"198"}]}]},{"code":"3.4","balance":"0.00","name":"RESULTADOS ACUMULADOS","parentid":"4","id":"210","children":[{"code":"3.4.1","balance":"0.00","name":"RESULTADOS DE LA ACTIVIDAD","parentid":"210","id":"211","children":[{"code":"3.4.1.2","balance":"0.00","name":"RESULTADO DEL EJERCICIO","parentid":"211","id":"215","children":[{"code":"3.4.1.2.01","balance":"2.46","name":"Ganancia (Pérdida) del ejercicio","parentid":"215","id":"216"}]}]}]}]},{"code":"4","balance":"43.59","name":"INGRESOS","parentid":"1","id":"5","children":[{"code":"4.1","balance":"43.59","name":"OPERACIONES CONTINUAS ORDINARIAS","parentid":"5","id":"227","children":[{"code":"4.1.1","balance":"43.59","name":"VENTAS NETAS DE MERCANIA GRAVABLES","parentid":"227","id":"228","children":[{"code":"4.1.1.1","balance":"43.59","name":"VENTAS BRUTAS DE MERCANCIA","parentid":"228","id":"229","children":[{"code":"4.1.1.1.01","balance":"43.59","name":"VENTAS BRUTAS DE MERCANCIA NACIONALES","parentid":"229","id":"230"}]}]}]},{"code":"4.2","balance":"0.00","name":"OPERACIONES CONTINUAS NO ORDINARIAS","parentid":"5","id":"234","children":[{"code":"4.2.1","balance":"0.00","name":"INGRESOS NO ORDINARIOS","parentid":"234","id":"235","children":[{"code":"4.2.1.1","balance":"0.00","name":"INGRESOS FINANCIEROS","parentid":"235","id":"236","children":[{"code":"4.2.1.1.04","balance":"0.00","name":"GANANCIA EN CAMBIO DE MONEDA EXTRANJERA","parentid":"236","id":"245"}]},{"code":"4.2.1.2","balance":"0.00","name":"OTROS INGRESOS NO ORDINARIOS","parentid":"235","id":"248","children":[{"code":"4.2.1.2.05","balance":"0.00","name":"OTRO TIPO DE INGRESOS NO ORDINARIOS","parentid":"248","id":"400"}]}]}]}]},{"code":"5","balance":"42.13","name":"COSTOS","parentid":"1","id":"6","children":[{"code":"5.2","balance":"42.13","name":"COSTO DE VENTA","parentid":"6","id":"292","children":[{"code":"5.2.1","balance":"42.13","name":"COSTO DE VENTA DE LA MERCANCÍA COMPRADA","parentid":"292","id":"293","children":[{"code":"5.2.1.1","balance":"42.13","name":"COMPRAS NETAS DE MERCANCÍA","parentid":"293","id":"294","children":[{"code":"5.2.1.1.01","balance":"42.13","name":"COMPRAS BRUTAS DE MERCANCÍA NACIONALES","parentid":"294","id":"295"}]}]}]}]},{"code":"6","balance":"0.00","name":"GASTOS","parentid":"1","id":"7","children":[{"code":"6.1","balance":"0.00","name":"OPERACIONES CONTÍNUAS ORDINARIAS","parentid":"7","id":"303","children":[{"code":"6.1.2","balance":"0.00","name":"GASTOS DE GESTIÓN ADMINISTRATIVA","parentid":"303","id":"331","children":[{"code":"6.1.2.1","balance":"0.00","name":"GASTOS DEL PERSONAL DE ADMINISTRACIÓN","parentid":"331","id":"332","children":[{"code":"6.1.2.1.01","balance":"0.00","name":"BENEFICIOS LABORALES REMUNERATIVOS DE ADMINISTRACIÓN","parentid":"332","id":"333","children":[{"code":"6.1.2.1.01-002","balance":"0.00","name":"Sueldos a Empleados","parentid":"333","id":"335"}]}]},{"code":"6.1.2.2","balance":"0.00","name":"GASTOS GENERALES DE ADMON.","parentid":"331","id":"353","children":[{"code":"6.1.2.2.02","balance":"0.00","name":"IMPUESTOS Y TASAS","parentid":"353","id":"357","children":[{"code":"6.1.2.2.02-001","balance":"0.00","name":"Pago ISLR","parentid":"357","id":"470"},{"code":"6.1.2.2.02-003","balance":"0.00","name":"Pago Otros Impuestos y Tasas","parentid":"357","id":"472"}]},{"code":"6.1.2.2.05","balance":"0.00","name":"GASTOS DE SERVICIOS PÚBLICOS DE ADMON.","parentid":"353","id":"360"},{"code":"6.1.2.2.06","balance":"0.00","name":"MATERIALES Y SUMINISTROS DE OFICINA DE ADMON.","parentid":"353","id":"361"}]}]},{"code":"6.1.3","balance":"0.00","name":"OTROS GASTOS ORDINARIOS","parentid":"303","id":"401","children":[{"code":"6.2.1.1","balance":"0.00","name":"OTROS GASTOS OPERATIVOS ORDINARIOS","parentid":"401","id":"402"}]}]},{"code":"6.2","balance":"0.00","name":"OPERACIONES CONTÍNUAS NO ORDINARIAS","parentid":"7","id":"372","children":[{"code":"6.2.1","balance":"0.00","name":"GASTOS NO ORDINARIOS","parentid":"372","id":"373","children":[{"code":"6.2.1.1","balance":"0.00","name":"GASTOS FINANCIEROS","parentid":"373","id":"374","children":[{"code":"6.2.1.1.06","balance":"0.00","name":"COMISIONES PAGADAS A INSTITUC. FINANCIERAS","parentid":"374","id":"403"}]}]}]}]}]}]}


                      console.log("RESPONSE", response)
    
                      if (selectedType[index] === 'excel') {
                        let newBody = { ...response }
  
                        newBody[
                          cardValues[index]?.currencyValue ||
                            'bsMonthlyBalanceSheet'
                        ] = addLevelToTree(
                          response[
                            cardValues[index]?.currencyValue ||
                              'bsMonthlyBalanceSheet'
                          ][0]?.children || []
                        )
    
                        const dt = DateTime.local()
  
                        let newDate = dt.toFormat('dd/MM/yyyy')
  
                        let data = newBody[
                          cardValues[index]?.currencyValue ||
                            'bsMonthlyBalanceSheet'
                        ].map((v) => [
                          v?.code,
                          v?.name,
                          formatPipe(v?.balance, false, 2, -9999999999999999999),
                        ])
  
                        onCreateBalanceSheetExcel({
                          date: newDate,
                          data,
                          imageUrl: infoAccount?.image,
                        })
                      } else {
                        let period =
                          selectedOptionValue?.text?.split('-')?.join('') || ''
  
                        let newBody = { ...response }

                        // console.log("OLD BODY", response[
                        //   cardValues[index]?.currencyValue ||
                        //     'bsMonthlyBalanceSheet'
                        // ])
  
                        newBody[
                          cardValues[index]?.currencyValue ||
                            'bsMonthlyBalanceSheet'
                        ] = addLevelToTree(
                          response[
                            cardValues[index]?.currencyValue ||
                              'bsMonthlyBalanceSheet'
                          ][0]?.children || []
                        )

                        // console.log("NEW BODY", newBody)
  
                        const blobValue = await pdf(
                          <BalanceSheetPdf
                            bodyValues={newBody}
                            type={
                              cardValues[index]?.currencyValue ||
                              'bsMonthlyBalanceSheet'
                            }
                            period={period}
                            infoAccount={infoAccount || {}} // Add fallback empty object
                            />
                        ).toBlob()
  
                        saveAs(blobValue, 'Estado_situacion_financiera')
                      }
                    } catch (err) {
                      console.log("MUESTRA DEL ERROR INDEX 01", err)
                      addAlert({ message: 'Reporte no disponible para el periodo seleccionado', status: 'error' })

                    }

                    // setOpenModal(true)
           
                  }}
                >
                  Descargar
                </label>
              </div>
            </div>
          </div>
        </>
      )
    }

    if (index === 1) {
      return (
        <>
          <div style={{ width: '100%' }}>
            <div className="flex flex-row justify-between">
              <div style={{ width: '45%' }}>
                <Select
                  options={optionsTypeTime}
                  label="Tipo"
                  defaultValue={optionsTypeTime[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      let newValue =
                        v?.value === 'monthly'
                          ? 'MonthlyDirectCashStatement'
                          : v?.value === 'quarterly'
                          ? 'QuarterlyDirectCashStatement'
                          : 'AnnualDirectCashStatement'

                      let values = [...cardValues]
                      values[index] = {
                        ...values[index],
                        bucketValue: newValue,
                      }

                      setCardValues(values)

                      getFilesBucket(newValue)
                    }
                  }}
                />
              </div>

              <div style={{ width: '45%' }}>
                <Select
                  options={optionsValues}
                  label="Periodo"
                  defaultValue={optionsValues[0]}
                  value={selectedOptionValue}
                  onChange={(v) => {
                    if (v?.value) {
                      let values = [...cardValues]
                      values[index] = {
                        ...values[index],
                        bucketDate: v?.value,
                      }

                      setCardValues(values)

                      setSelectedOptionValue(v)
                    }
                  }}
                />
              </div>
            </div>

            <div className="flex flex-row justify-between">
              <div style={{ width: '45%' }}>
                <Select
                  options={options}
                  label="Tipo de archivo"
                  defaultValue={options[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      setSelectedType((prevState) => ({
                        ...prevState,
                        [index]: v?.value,
                      }))
                    }
                  }}
                />
              </div>

              {/* <div style={{ width: '45%' }}>
                <Select
                  options={currencyOptions}
                  label="Moneda"
                  defaultValue={currencyOptions[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      setSelectedCurrencyOption(v?.value)
                    }
                  }}
                />
              </div> */}
            </div>

            <div style={{ width: '100%', marginTop: 15 }}>
              <div className="flex flex-row justify-center">
                <label
                  className="text-primary text-base font-medium cursor-pointer"
                  onClick={async () => {
                    console.log("CARD VALUES", cardValues[index])

                    let [bucketDateMonth, bucketDateYear] = cardValues[
                      index
                    ]?.bucketDate?.split('-')

                    // setOpenModal(true)

                    // return

                    console.log("SELECTED", selectedOptionValue)



                    try {
                    const response = await getJsonFromS3(
                      user['custom:tenant_id'],
                      cardValues[index]?.bucketValue ===
                        'AnnualDirectCashStatement'
                        ? `${cardValues[index]?.bucketValue}-${bucketDateMonth}.json`
                        : `${cardValues[index]?.bucketValue}-${bucketDateYear}-${bucketDateMonth}.json`
                    )



                    let period = selectedOptionValue?.text?.split('-')

                    if (selectedType[index] === 'excel') {
                      onCreateCashFlowExcel({
                        date: `${monthTransform[period[0]] || period[0]} ${period[1]}`,
                        data:
                          response[
                            cardValues[index]?.currencyValue ||
                              'bsDirectCashFlowStatement'
                          ],
                        imageUrl: infoAccount?.image,
                      })
                    } else {
                      const blobValue = await pdf(
                        <CashPdf
                          bodyValues={response}
                          type={'bsDirectCashFlowStatement'}
                          period={`${monthTransform[period[0]] || period[0]} ${period[1]}`}
                          infoAccount={infoAccount || {}} // Add fallback empty object
                          />
                      ).toBlob()

                      saveAs(blobValue, 'Estado_flujo_efectivo')
                    }
                    } catch (err) {
                      console.log("MUESTRA DEL ERROR INDEX 02", err)
                      addAlert({ message: 'Reporte no disponible para el periodo seleccionado', status: 'error' })
                    }

                  }}
                >
                  Descargar
                </label>
              </div>
            </div>
          </div>
        </>
      )
    }

    if (index === 2) {
      return (
        <>
          <div style={{ width: '100%' }}>
            <div className="flex flex-row justify-between">
              <div style={{ width: '45%' }}>
                <Select
                  options={optionsTypeTime}
                  label="Tipo"
                  defaultValue={optionsTypeTime[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      let newValue =
                        v?.value === 'monthly'
                          ? 'MonthlyIncomeStatement'
                          : v?.value === 'quarterly'
                          ? 'QuarterlyIncomeStatement'
                          : 'AnnualIncomeStatement'

                      if (
                        newValue === 'MonthlyIncomeStatement' &&
                        selectedCurrencyIncomeStatement?.startsWith('usd')
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'usdMonthlyIncomeStatement'
                        )
                      }

                      if (
                        newValue === 'QuarterlyIncomeStatement' &&
                        selectedCurrencyIncomeStatement?.startsWith('usd')
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'usdQuarterlyIncomeStatement'
                        )
                      }

                      if (
                        newValue === 'AnnualIncomeStatement' &&
                        selectedCurrencyIncomeStatement?.startsWith('usd')
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'usdAnnualIncomeStatement'
                        )
                      }

                      if (
                        newValue === 'MonthlyIncomeStatement' &&
                        selectedCurrencyIncomeStatement?.startsWith('bs')
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'bsMonthlyIncomeStatement'
                        )
                      }

                      if (
                        newValue === 'QuarterlyIncomeStatement' &&
                        selectedCurrencyIncomeStatement?.startsWith('bs')
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'bsQuarterlyIncomeStatement'
                        )
                      }

                      if (
                        newValue === 'AnnualIncomeStatement' &&
                        selectedCurrencyIncomeStatement?.startsWith('bs')
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'bsAnnualIncomeStatement'
                        )
                      }

                      let values = [...cardValues]
                      values[index] = {
                        ...values[index],
                        bucketValue: newValue,
                      }

                      setCardValues(values)

                      getFilesBucketIncomeStatement(newValue)
                    }
                  }}
                />
              </div>

              <div style={{ width: '45%' }}>
                <Select
                  options={optionsValuesIncomeStatement}
                  label="Periodo"
                  defaultValue={optionsValuesIncomeStatement[0]}
                  value={selectedOptionValueIncomeStatement}
                  onChange={(v) => {
                    if (v?.value) {
                      let values = [...cardValues]
                      values[index] = {
                        ...values[index],
                        bucketDate: v?.value,
                      }

                      setCardValues(values)

                      setSelectedOptionValueIncomeStatement(v)
                    }
                  }}
                />
              </div>
            </div>

            <div className="flex flex-row justify-between">
              <div style={{ width: '45%' }}>
                <Select
                  options={options}
                  label="Tipo de archivo"
                  defaultValue={options[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      setSelectedType((prevState) => ({
                        ...prevState,
                        [index]: v?.value,
                      }))
                    }
                  }}
                />
              </div>

              {/* <div style={{ width: '45%' }}>
                <Select
                  options={currencyOptionsIncomeStatement}
                  label="Moneda"
                  defaultValue={currencyOptionsIncomeStatement[0]}
                  onChange={(v) => {
                    if (v?.value) {
                      if (
                        v?.value === 'usdMonthlyIncomeStatement' &&
                        cardValues[index].bucketValue ===
                          'MonthlyIncomeStatement'
                      ) {
                        setSelectedCurrencyIncomeStatement(v?.value)
                      }

                      if (
                        v?.value === 'usdMonthlyIncomeStatement' &&
                        cardValues[index].bucketValue ===
                          'QuarterlyIncomeStatement'
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'usdQuarterlyIncomeStatement'
                        )
                      }

                      if (
                        v?.value === 'usdMonthlyIncomeStatement' &&
                        cardValues[index].bucketValue ===
                          'AnnualIncomeStatement'
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'usdAnnualIncomeStatement'
                        )
                      }

                      if (
                        v?.value === 'bsMonthlyIncomeStatement' &&
                        cardValues[index].bucketValue ===
                          'MonthlyIncomeStatement'
                      ) {
                        setSelectedCurrencyIncomeStatement(v?.value)
                      }

                      if (
                        v?.value === 'bsMonthlyIncomeStatement' &&
                        cardValues[index].bucketValue ===
                          'QuarterlyIncomeStatement'
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'bsQuarterlyIncomeStatement'
                        )
                      }

                      if (
                        v?.value === 'bsMonthlyIncomeStatement' &&
                        cardValues[index].bucketValue ===
                          'AnnualIncomeStatement'
                      ) {
                        setSelectedCurrencyIncomeStatement(
                          'bsAnnualIncomeStatement'
                        )
                      }
                    }
                  }}
                />
              </div> */}
            </div>

            <div style={{ width: '100%', marginTop: 15 }}>
              <div className="flex flex-row justify-center">
                <label
                  className="text-primary text-base font-medium cursor-pointer"
                  onClick={async () => {
                    // let [bucketDateMonth, bucketDateYear] = cardValues[
                    //   index
                    // ]?.bucketDate?.split('-')

                    // try {
                    //   const response = await getJsonFromS3(
                    //     user['custom:tenant_id'],
                    //     cardValues[index]?.bucketValue === 'AnnualIncomeStatement'
                    //       ? `${cardValues[index]?.bucketValue}-${bucketDateMonth}.json`
                    //       : `${cardValues[index]?.bucketValue}-${bucketDateYear}-${bucketDateMonth}.json`
                    //   )
  
                    //   let responsePrueba = addLevelToTree(
                    //     response[
                    //       selectedCurrencyIncomeStatement ||
                    //         'usdMonthlyIncomeStatement'
                    //     ][0]?.children || []
                    //   )
  
                    //   response[
                    //     selectedCurrencyIncomeStatement ||
                    //       'usdMonthlyIncomeStatement'
                    //   ] = responsePrueba
  
  
                    //   let period = selectedOptionValueIncomeStatement?.text?.split(
                    //     '-'
                    //   )
  
                    //   if (selectedType[index] === 'excel') {
                    //     let data = response[
                    //       cardValues[index]?.currencyValue ||
                    //         'usdMonthlyIncomeStatement'
                    //     ].map((v) => [
                    //       v?.code,
                    //       v?.name,
                    //       v?.bsBalance
                    //         ? formatPipe(
                    //             v?.bsBalance,
                    //             false,
                    //             2,
                    //             -9999999999999999999
                    //           )
                    //         : v?.bsNetIncome
                    //         ? formatPipe(
                    //             v?.bsNetIncome,
                    //             false,
                    //             2,
                    //             -9999999999999999999
                    //           )
                    //         : v?.usdNetIncome
                    //         ? formatPipe(
                    //             v?.usdNetIncome,
                    //             false,
                    //             2,
                    //             -9999999999999999999
                    //           )
                    //         : formatPipe(v?.usdBalance, false, 2, -9999999999999),
                    //     ])
  
                    //     onCreateEstadoResultado({
                    //       date: `${monthTransform[period[0]]} ${period[1]}`,
                    //       data,
                    //       imageUrl: infoAccount?.image,
                    //     })
                    //   } else {
                    //     const blobValue = await pdf(
                    //       <EstadoResultadoPDF
                    //         bodyValues={response}
                    //         type={selectedCurrencyIncomeStatement}
                    //         period={`${monthTransform[period[0]]} ${period[1]}`}
                    //         infoAccount={infoAccount}
                    //       />
                    //     ).toBlob()
  
                    //     saveAs(blobValue, 'Estado_resultados')
                    //   }
                    // } catch (err) {
                    //   addAlert({ message: 'Reporte no disponible para el periodo seleccionado', status: 'error' })
                    // }

                    setOpenModal(true)

                
                  }}
                >
                  Descargar
                </label>
              </div>
            </div>
          </div>
        </>
      )
    }

    if (index === 3) {
      return (
        <>
          <div className="flex flex-row justify-between">
            <div style={{ width: '45%' }}>
              <Datepicker
                label="Fecha inicio"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    startedDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
            <div style={{ width: '45%' }}>
              <Datepicker
                calendarPosition={100}
                label="Fecha fin"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    endDate: value,
                  }
                   

                  setCardValues(values)
                }}
              />
            </div>
          </div>

          <div style={{ width: '45%' }}>
            <Select
              options={options}
              label="Tipo de archivo"
              defaultValue={options[0]}
              onChange={(v) => {
                if (v?.value) {
                  setSelectedType((prevState) => ({
                    ...prevState,
                    [index]: v?.value,
                  }))
                }
              }}
            />
          </div>
          <div style={{ width: '100%', marginTop: 15 }}>
            <div className="flex flex-row justify-center">
              <label
                className="text-primary text-base font-medium cursor-pointer"
                onClick={async () => {
                  addAlert({ message: 'Descargando', status: 'loading' })

                  const [day, month, year] = cardValues[index]?.endDate.split(
                    '/'
                  )

                  const dt = DateTime.local(+year, +month, +day).plus({
                    days: 1,
                  })

                  let newDate = dt.toFormat('dd/MM/yyyy')

                  try {
                    let response = await axios.get<{ records: any[] }>(
                      `${server}/accounting/record?pageNumber=1&pageSize=10000&fromDate=${dateToDB(
                        cardValues[index]?.startedDate
                      )}&toDate=${dateToDB(newDate)}`
                    )

                    let data = response.data.records
                      .map((v) => [
                        DateTime.fromISO(v?.date).toFormat('dd/MM/yyyy'),
                        formatPipe(v?.amount, false, 2, -99999999999999999999),
                        v?.description,
                        v?.type === 'DEBIT' ? 'DEBE' : 'HABER',
                        v?.code,
                        v?.name,
                      ])
                      .reverse()

                    if (selectedType[index] === 'excel') {
                      console.log("DIARY BOOK", data)
                      await onCreateDiaryBookExcel({
                        startedDate: cardValues[index]?.startedDate,
                        endDate: cardValues[index]?.endDate,
                        data,
                        document: `${infoAccount?.document?.documentType}-${infoAccount?.document?.document}`,
                        name: infoAccount?.businessSocial,
                        imageUrl: infoAccount?.image,
                      })
                    } else {
                      await generatePdf(
                        index,
                        response.data.records.reverse(),
                        {}
                      )
                    }

                    addAlert({
                      message: 'Reporte generado satisfactoriamente',
                      status: 'success',
                    })
                  } catch (err) {
                    addAlert({ message: 'Reporte no disponible para el periodo seleccionado', status: 'error' })
                  }

                  // setOpenModal(true)
                }}
              >
                Descargar
              </label>
            </div>
          </div>
        </>
      )
    }
    if (index === 4) {
      return (
        <>
          <div className="flex flex-row justify-between">
            <div style={{ width: '45%' }}>
              <Datepicker
                label="Fecha inicio"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    startedDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
            <div style={{ width: '45%' }}>
              <Datepicker
                calendarPosition={100}
                label="Fecha fin"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    endDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
          </div>

          <div className="flex flex-row justify-between">
            <div style={{ width: '45%' }}>
              <Select
                options={options}
                label="Tipo de archivo"
                defaultValue={options[0]}
                onChange={(v) => {
                  if (v?.value) {
                    setSelectedType((prevState) => ({
                      ...prevState,
                      [index]: v?.value,
                    }))
                  }
                }}
              />
            </div>

            <div style={{ width: '45%' }}>
              <RawAutoComplete
                label="Cuenta contable"
                url={`accounting/simple-search`}
                bodyGet={'accounts'}
                queryParam={'search'}
                selectedValue={undefined}
                setSelectedValue={async (value) => {
                  if (value?.idParent) {
                    let response = await axios.get(
                      `${server}/accounting?id=${value?.idParent}`
                    )
                    setAccountPayable({
                      ...value,
                      parentCode: response.data.code,
                      parentName: response.data.name,
                      parentBalance: response.data.balance,
                    })
                  } else {
                    setAccountPayable(null)
                  }
                }}
              />
            </div>
          </div>

          <div style={{ width: '100%', marginTop: 15 }}>
            <div className="flex flex-row justify-center">
              <label
                className="text-primary text-base font-medium cursor-pointer"
                onClick={async () => {
                  if (!accountPayable) {
                    addAlert({
                      message: 'Debe de ingresar la cuenta contable',
                      status: 'error',
                    })
                    return
                  }

                  addAlert({ message: 'Descargando', status: 'loading' })

                  const [day, month, year] = cardValues[index]?.endDate.split(
                    '/'
                  )

                  const dt = DateTime.local(+year, +month, +day).plus({
                    days: 1,
                  })

                  let newDate = dt.toFormat('dd/MM/yyyy')

                  try {
                    let url = accountPayable
                      ? `${server}/accounting/record?pageNumber=1&pageSize=10000&fromDate=${dateToDB(
                          cardValues[index]?.startedDate
                        )}&toDate=${dateToDB(newDate)}&accountId=${
                          accountPayable?.id
                        }`
                      : `${server}/accounting/record?pageNumber=1&pageSize=10000&fromDate=${dateToDB(
                          cardValues[index]?.startedDate
                        )}&toDate=${dateToDB(newDate)}`

                    let response = await axios.get<{ records: any[] }>(url)

                    // let valueBefore = response.data.records.reduce((a, b) => {
                    //   return a + +toFixed(+b?.amount, 2)
                    // }, 0)

                    // console.log("VALUE", value)
                    // console.log("VALUE 02", response.data.records)

                    // setBeforeBalance(+toFixed(value, 2))

                    const [dayStarted, monthStarted, yearStarted] = cardValues[
                      index
                    ]?.startedDate.split('/')

                    const [dayEnd, monthEnd, yearEnd] = cardValues[
                      index
                    ]?.endDate.split('/')

                    const dt = DateTime.local(
                      +yearStarted,
                      +monthStarted,
                      +dayStarted
                    )

                    const dtEnd = DateTime.local(+yearEnd, +monthEnd, +dayEnd)

                    const startedDate = dt.minus({ days: 1 })

                    const todayDate = DateTime.now()

                    // console.log("VER...", dt.toISODate() === todayDate.toISODate())

                    let beforeBalance
                    let finalBalance = accountPayable.parentBalance

                    if (dtEnd.toISODate() === todayDate.toISODate()) {
                      let balanceReponse = await axios.get(
                        `${server}/accounting/previous-balance?id=${
                          accountPayable?.id
                        }&date=${dateToDB(startedDate.toFormat('dd/MM/yyyy'))}`
                      )
                      //Hacer segunda peticion aca
                      beforeBalance = balanceReponse?.data?.balance
                    } else {
                      const [responseStart, responseEnd] = await Promise.all([
                        axios.get(
                          `${server}/accounting/previous-balance?id=${
                            accountPayable.id
                          }&date=${dateToDB(
                            startedDate.toFormat('dd/MM/yyyy')
                          )}`
                        ),
                        axios.get(
                          `${server}/accounting/previous-balance?id=${
                            accountPayable.id
                          }&date=${dateToDB(dtEnd.toFormat('dd/MM/yyyy'))}`
                        ),
                      ])

                      beforeBalance = responseStart?.data?.balance

                      finalBalance = responseEnd?.data?.balance
                    }


                    let data = response.data.records
                      .map((v) => [
                        DateTime.fromISO(v?.date).toFormat('dd/MM/yyyy'),
                        v?.type === 'DEBIT' ? 'DEBE' : 'HABER',
                        v?.description,
                        formatPipe(v?.amount),
                      ])
                      .reverse()

                    if (selectedType[index] === 'excel') {
                      await onCreateAnalysisBookExcel({
                        startedDate: cardValues[index]?.startedDate,
                        endDate: cardValues[index]?.endDate,
                        data,
                        document: `${infoAccount?.document?.documentType}-${infoAccount?.document?.document}`,
                        name: infoAccount?.businessSocial,
                        imageUrl: infoAccount?.image,
                        accountName: accountPayable?.name,
                        accountCode: accountPayable?.code,
                        parentCode: accountPayable?.parentCode,
                        parentName: accountPayable?.parentName,
                        parentBalance: formatPipe(
                          toFixed(finalBalance, 2),
                          false,
                          2,
                          -9999999999999999999
                        ),
                        parentBeforeBalance: formatPipe(
                          toFixed(beforeBalance, 2),
                          false,
                          2,
                          -9999999999999999999
                        ),
                      })
                    } else {
                      await generatePdf(
                        index,
                        response.data.records.reverse(),
                        { beforeBalance, finalBalance }
                      )
                    }

                    addAlert({
                      message: 'Reporte generado satisfactoriamente',
                      status: 'success',
                    })
                  } catch (err) {
                    addAlert({ message: 'Reporte no disponible para el periodo seleccionado', status: 'error' })
                  }

                  // setOpenModal(true)
                }}
              >
                Descargar
              </label>
            </div>
          </div>
        </>
      )
    }
    if (index === 5) {
      return (
        <>
          <div className="flex flex-row justify-between">
            <div style={{ width: '45%' }}>
              <Datepicker
                label="Fecha inicio"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    startedDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
            <div style={{ width: '45%' }}>
              <Datepicker
                calendarPosition={100}
                label="Fecha fin"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    endDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
          </div>

          <div className="flex flex-row justify-between">
            <div style={{ width: '45%' }}>
              <Select
                options={logOptionsType}
                label="Tipo"
                defaultValue={logOptionsType[0]}
                onChange={(v) => {
                  if (v?.value) {
                    setSelectedType((prevState) => ({
                      ...prevState,
                      [index]: v?.value,
                    }))
                  }
                }}
              />
            </div>

            <div style={{ width: '45%' }}>
              <InputText
                label="Usuario"
                innerProps={{
                  onKeyUp: (e: any) => {
                    let values = [...cardValues]

                    values[index] = {
                      ...values[index],
                      username: e.target.value,
                    }

                    setCardValues(values)
                  },
                }}
              />
            </div>
          </div>

          <div style={{ width: '100%', marginTop: 15 }}>
            <div className="flex flex-row justify-center">
              <label
                className="text-primary text-base font-medium cursor-pointer"
                onClick={async () => {
                  try {
                    const { startedDate, endDate, ...rest } = cardValues[index]

                    const [daySt, monthSt, yearst] = startedDate.split('/')
  
                    const dtStarted = DateTime.local(
                      +yearst,
                      +monthSt,
                      +daySt
                    )
                    // .plus({
                    //   days: 1,
                    // })
  
                    let newDateStarted = dtStarted.toFormat('dd/MM/yyyy')
  
                    const [dayEnd, monthEnd, yearEnd] = endDate.split('/')
  
                    const dtEnd = DateTime.local(
                      +yearEnd,
                      +monthEnd,
                      +dayEnd
                    ).plus({
                      days: 1,
                    })
  
                    let newDateEnd = dtEnd.toFormat('dd/MM/yyyy')
  
                    await onGetLogs(0, {
                      ...rest,
                      fromDate: dateToDB(newDateStarted),
                      toDate: dateToDB(newDateEnd),
                      type: selectedType[index],
                    })
                  } catch (err) {
                    addAlert({ message: 'Reporte no disponible para el periodo seleccionado', status: 'error' })
                  }
                  
                  // setOpenModal(true)
                }}
              >
                Obtener eventos
              </label>
            </div>
          </div>
        </>
      )
    }

    if (index === 6) {
      return (
        <>
           <div className="flex flex-row justify-between">
            <div style={{ width: '45%' }}>
              <Datepicker
                label="Fecha inicio"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    startedDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
            <div style={{ width: '45%' }}>
              <Datepicker
                calendarPosition={100}
                label="Fecha fin"
                onChangeDate={(value) => {
                  let values = [...cardValues]
                  values[index] = {
                    ...values[index],
                    endDate: value,
                  }

                  setCardValues(values)
                }}
              />
            </div>
          </div>

          <div style={{ width: '100%', marginTop: 70 }}>
              <div className="flex flex-row justify-center">
                <label
                  className="text-primary text-base font-medium cursor-pointer"
                  onClick={async () => {

                    const startDate = DateTime.fromJSDate(new Date()).toFormat('dd/MM/yyyy')
                    const endDate = DateTime.fromJSDate(new Date()).toFormat('dd/MM/yyyy')

                    console.log("START DATE", startDate)
                    console.log("END DATE", endDate)
                    try {
                      let resp = await axios.get(`${server}/report/sales-book?from=${dateToDB(cardValues[index]?.startedDate || startDate)}&to=${dateToDB(cardValues[index]?.endDate ||  endDate)}`)
                      
                      if (resp.data?.salesBook?.length  === 0 || resp?.status === 204) {
                        addAlert({ message: 'No se encontraron ventas para el periodo seleccionado', status: 'error' })
                        return
                      }


                      setSalesBook(resp.data?.salesBook)
                      // await generatePdf(index, {}, {})

                    } catch(err) {

                    }
                  }}
                >
                  Descargar
                </label>
              </div>
            </div>

        </>
      )
    }
  }

  const onDownloadSalesBook = async () => {
    if (salesBook && infoAccount) {
      const endDate = cardValues[6]?.endDate || DateTime.fromJSDate(new Date()).toFormat('dd/MM/yyyy')
      const blob = await pdf(
        <SalesBook
          dateFrom={cardValues[6]?.startedDate}
          dateTo={cardValues[6]?.endDate || endDate}
          infoAccount={infoAccount}
          salesBook={{...salesBook, sales: salesBook?.sales?.map((x, idx) => ({...x, nroOpe: idx + 1}))}}
          thermalPrinter={thermalPrinter}
        />
      ).toBlob()
      saveAs(blob, 'Libro de ventas')

      return
    }
  }

  useEffect(() => {
    onDownloadSalesBook()
  }, [salesBook, infoAccount, thermalPrinter])

  return (
    <>
      {logsState.logs && logsState.logs.length > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Button
            classes="border-none mb-5"
            onClick={() => {
              setLogsState(prevState => ({
                ...prevState,
                logs: []
              }))
            }}
            type="arrow"
            warehouseType={'SALE FLOOR'}
          >
            <FaArrowLeft size={30} />
          </Button>

          <Table
            data={logsState.logs}
            columns={columns}
            pages={logsState.numberOfPages}
            pageSelected={logsState.currentPage}
            loading={logsState.loading}
            setPageSelected={(page) => onGetLogs(page, logsState.filterValues)}
            setLoading={(v) => {
              setLogsState((prevState) => ({
                ...prevState,
                loading: v,
              }))
            }}
          />
        </motion.div>
      )}

      {logsState.logs && logsState.logs.length === 0 && (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
          {/* // <div style={{height: '100vh'}}> */}

          {/* <CashPdf /> */}

          {cardOptions.map((card, idx) => (
            <div
              className="2xl:w-96 w-96 h-60 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl relative dark:bg-black m-auto"
              onClick={() => onClickCard(idx)}
            >
              <div className="flex">
                <div
                  style={{
                    backgroundColor: '#006AEA33',
                    height: 30,
                    width: 30,
                  }}
                  className="flex justify-center items-center"
                >
                  <card.icon color="#0033A0" />
                </div>

                <div className="ml-3">
                  <label className="text-base font-medium">{card.title}</label>
                </div>
              </div>

              <div
                style={{
                  width: '100%',
                  height: 2,
                  backgroundColor: '#CFCDCD',
                  marginTop: 10,
                }}
              ></div>

              <div className="mt-2">{renderContent(idx)}</div>
            </div>
          ))}

          <Modal
            display={openModal}
            onClose={() => setOpenModal(false)}
            xlClasses="w-md"

          >
            <div className="text-center p-1">
              <h2 className="text-2xl font-bold text-primary-900 dark:text-white mb-3">Reportes en Mantenimiento</h2>
              <p className="text-gray-600 dark:text-gray-300">
                Estimado usuario, los reportes se encuentran temporalmente en mantenimiento. 
                Disculpe las molestias ocasionadas.
              </p>
              <p className="text-gray-600 dark:text-gray-300 mt-2">
                Estamos trabajando para brindarle un mejor servicio.
              </p>
            </div>
          </Modal>
        </div>
      )}
    </>
  )
}

interface dataRecords {
  date: string
  amount: string
  description: string
  type: string
  name: string
}

export default Reports
